import { UiState, EditionType } from '../state/UiState';
import { t } from '../i18n/i18n';

export class EditionSimulatorBar {
  private element: HTMLElement;
  private uiState: UiState;
  private titleLabelEl: HTMLElement | null = null;
  private btnWebFreeEl: HTMLButtonElement | null = null;
  private btnPaidEl: HTMLButtonElement | null = null;

  constructor(uiState: UiState) {
    this.uiState = uiState;
    this.element = document.createElement('div');
    this.element.className = 'edition-simulator-bar';
    this.render();

    this.uiState.subscribe((state) => {
      this.updateActiveButton(state.edition);
      this.updateTexts();
    });
  }

  getElement(): HTMLElement {
    return this.element;
  }

  private render(): void {
    const texts = t();

    this.element.innerHTML = `
      <div class="title">
        <span>🎮</span>
        <span id="simTitleLabel">${texts.sim.label}</span>
      </div>
      <div class="edition-switch">
        <button class="edition-btn ${this.uiState.getSnapshot().edition === 'web_free' ? 'active' : ''}" data-edition="web_free" id="btnSimWebFree">
          ${texts.sim.webFree}
        </button>
        <button class="edition-btn ${this.uiState.getSnapshot().edition === 'pc_app_paid' ? 'active' : ''}" data-edition="pc_app_paid" id="btnSimPaid">
          ${texts.sim.mobilePaid}
        </button>
      </div>
    `;

    this.titleLabelEl = this.element.querySelector('#simTitleLabel');
    this.btnWebFreeEl = this.element.querySelector('#btnSimWebFree');
    this.btnPaidEl = this.element.querySelector('#btnSimPaid');

    this.element.querySelectorAll<HTMLButtonElement>('.edition-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetEdition = btn.getAttribute('data-edition') as EditionType;
        if (targetEdition) {
          this.uiState.setEdition(targetEdition);
        }
      });
    });
  }

  private updateTexts(): void {
    const texts = t();
    if (this.titleLabelEl) this.titleLabelEl.textContent = texts.sim.label;
    if (this.btnWebFreeEl) this.btnWebFreeEl.textContent = texts.sim.webFree;
    if (this.btnPaidEl) this.btnPaidEl.textContent = texts.sim.mobilePaid;
  }

  private updateActiveButton(currentEdition: EditionType): void {
    this.element.querySelectorAll<HTMLButtonElement>('.edition-btn').forEach((btn) => {
      const edition = btn.getAttribute('data-edition');
      const isActive = edition === currentEdition || (currentEdition !== 'web_free' && edition === 'pc_app_paid');
      btn.classList.toggle('active', isActive);
    });
  }
}
